import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import {
  designarCertificadoServico,
  fetchCertificadosServico,
  retirarCertificadoServico,
} from '../api/certificadoServico';

const QUERY_KEY = ['admin', 'certificados-servico'] as const;

export function useCertificadosServico() {
  return useQuery({
    queryKey: QUERY_KEY,
    queryFn: fetchCertificadosServico,
  });
}

export function useDesignarCertificadoServico() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: designarCertificadoServico,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: QUERY_KEY });
    },
  });
}

export function useRetirarCertificadoServico() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: retirarCertificadoServico,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: QUERY_KEY });
    },
  });
}
